export const Lang_Types = {
    'ES-CO': 'es-CO',
    'EN-US': 'en-US',
};
